<template>
    <el-dialog
      title="成果预览"
      :visible.sync="dialogVisible"
      width="1200px"
      top="5vh"
      class="achievement-preview-dialog"
      :close-on-click-modal="false"
      @close="handleClose"
    >
      <div class="preview-container" v-loading="loading">
   
  
  
        <el-collapse  accordion >
    <el-collapse-item title="成果方成果延伸服务申请详情" name="1">
      <div class="borderTop"></div>
      <div class="pd30" >
        <div class="formHeader mt30">
            <div class="line"></div>
            <div class="formHeaderText">申请人信息</div>
          </div>
          <div>
            <el-descriptions  direction="vertical" :column="4" border>
                <el-descriptions-item label="单位" :span="4">{{copDetail.contacts_org}}</el-descriptions-item>
              <el-descriptions-item label="职务">{{copDetail.contacts_position}}</el-descriptions-item>
              <el-descriptions-item label="姓名">{{copDetail.contacts_name}}</el-descriptions-item>
              <el-descriptions-item label="电话">{{copDetail.contacts_phone}}</el-descriptions-item>
              <el-descriptions-item label="提交时间">{{copDetail.add_date}}</el-descriptions-item>
            </el-descriptions>
          </div>
  
  
  
          <div class="formHeader mt30">
            <div class="line"></div>
            <div class="formHeaderText">发布会科技成果</div>
          </div>
          <div>
            <el-descriptions  direction="vertical" :column="4" border>
    <el-descriptions-item label="发布会科技成果名称" :span="4">{{achievementDetail.name}}</el-descriptions-item>
    <el-descriptions-item label="发布会科技成果简介" :span="4">
                <div v-html="achievementDetail?.profile"></div>
    </el-descriptions-item>
    <el-descriptions-item label="发布会科技成果领域">{{achievementDetail.scope_str}}</el-descriptions-item>
    <el-descriptions-item label="申报单位">{{achievementDetail.org_name}}</el-descriptions-item>
    <el-descriptions-item label="项目地区">{{achievementDetail.org_province_name}}</el-descriptions-item>
    <el-descriptions-item label="项目推荐单位">{{achievementDetail.recommend_org_name}}</el-descriptions-item>
          </el-descriptions>
          </div>
          <div class="formHeader mt30">
            <div class="line"></div>
            <div class="formHeaderText">精准化供需对接推介活动</div>
          </div>
          <div>
       <el-descriptions  direction="vertical" :column="3" border>
    <el-descriptions-item label="定向推介活动">{{formatValue(copDetail.directional)}}</el-descriptions-item>
    <el-descriptions-item label="专项推介活动">{{formatValue(copDetail.special)}}</el-descriptions-item>
    <el-descriptions-item label="专题推介活动">{{formatValue(copDetail.special_subject)}}</el-descriptions-item>
          </el-descriptions>
          </div>
          <div class="formHeader mt30">
            <div class="line"></div>
            <div class="formHeaderText">专业化诊断评价策划业务
            </div>
          </div>
          <div>
            <el-descriptions  direction="vertical" :column="4" border>
    <el-descriptions-item label="项目过滤筛选">{{formatValue(copDetail.filter)}}</el-descriptions-item>
    <el-descriptions-item label="项目对接撮合">{{formatValue(copDetail.matchmaking)}}</el-descriptions-item>
    <el-descriptions-item label="项目策划促进">{{formatValue(copDetail.planning_promotion)}}</el-descriptions-item>
    <el-descriptions-item label="项目落地平台">{{formatValue(copDetail.landing_platform)}}</el-descriptions-item>
          </el-descriptions>
          </div>
          <div class="formHeader mt30">
            <div class="line"></div>
            <div class="formHeaderText">数字化云网智能服务平台
            </div>
          </div>
          <div>
            <el-descriptions  direction="vertical" :column="1" border>
    <el-descriptions-item label="数字化云网智能服务平台">{{formatValue(copDetail.digitized_cloud)}}</el-descriptions-item>
          </el-descriptions>
          </div>
          <div class="formHeader mt30">
            <div class="line"></div>
            <div class="formHeaderText">常态化共建科创实体机构
            </div>
          </div>
          <div>
            <el-descriptions  direction="vertical" :column="3" border>
    <el-descriptions-item label="地区合作机构">{{formatValue(copDetail.regional)}}</el-descriptions-item>
    <el-descriptions-item label="行业合作机构">{{formatValue(copDetail.industry)}}</el-descriptions-item>
    <el-descriptions-item label="国际合作机构">{{formatValue(copDetail.international)}}</el-descriptions-item>
          </el-descriptions>
          
          </div>

          <div class="formHeader mt30">
            <div class="line"></div>
            <div class="formHeaderText">生态化落地项目育成工场

            </div>
          </div>
          <div>
            <el-descriptions  direction="vertical" :column="5" border>
    <el-descriptions-item label="资本市场投资项目">{{formatValue(copDetail.capital_market)}}</el-descriptions-item>
    <el-descriptions-item label="产业园区招商项目">{{formatValue(copDetail.investment_promotion)}}</el-descriptions-item>
    <el-descriptions-item label="地区经济产业项目">{{formatValue(copDetail.economic_industry)}}</el-descriptions-item>

    <el-descriptions-item label="大型企业重大项目">{{formatValue(copDetail.large_enterprises)}}</el-descriptions-item>
    <el-descriptions-item label="中小企业跃升项目">{{formatValue(copDetail.medium_sized)}}</el-descriptions-item>
          </el-descriptions>
          
          </div>
  

      </div>
    </el-collapse-item>
    <el-collapse-item title="预览申报成果信息登记表" name="2">
      <div class="borderTop"></div>
      <div class="pd30">
        <div class="reTitle mt20">科技成果转化双推双促工程</div>
      <div class="reTitle mt20">《申报成果信息登记表》</div>
      <div class="formHeader mt30">
            <div class="line"></div>
            <div class="formHeaderText">申报单位信息</div>
          </div>
          <el-descriptions :column="2" border label-width="120px">
              <el-descriptions-item labelClassName="labelClass" label="申报单位名称" :span="2">{{achievementDetail?.org_name}}</el-descriptions-item>
              <el-descriptions-item labelClassName="labelClass" label="单位所在省/市">{{achievementDetail?.org_province_name}}</el-descriptions-item>
              <el-descriptions-item labelClassName="labelClass" label="单位成立时间">{{achievementDetail?.establish_date}}</el-descriptions-item>
              <el-descriptions-item labelClassName="labelClass" label="单位产业属性">{{achievementDetail?.industrial_str}}</el-descriptions-item>
              <el-descriptions-item labelClassName="labelClass" label="单位业务属性">{{achievementDetail?.business_str}}</el-descriptions-item>
              <el-descriptions-item labelClassName="labelClass" label="单位从业人数（人）">{{achievementDetail?.org_person}}</el-descriptions-item>
              <el-descriptions-item labelClassName="labelClass" label="单位负责人姓名">{{achievementDetail?.org_leader}}</el-descriptions-item>
              <el-descriptions-item labelClassName="labelClass" label="成果申报人">{{achievementDetail?.declarant_name}}</el-descriptions-item>
              <el-descriptions-item labelClassName="labelClass" label="申报人联系方式">{{achievementDetail?.declarant_mobile}}</el-descriptions-item>
            </el-descriptions>
  
            <div class="formHeader mt30">
            <div class="line"></div>
            <div class="formHeaderText">申报成果信息</div>
          </div>
          <el-descriptions :column="1" direction="vertical" border label-width="120px">
              <el-descriptions-item  label="申报成果名称" >{{achievementDetail?.name}}</el-descriptions-item>
              <el-descriptions-item  label="成果所属领域" >{{achievementDetail?.scope_str}}</el-descriptions-item>
              <el-descriptions-item  label="成果简介" >
                <div v-html="achievementDetail?.profile"></div>
              </el-descriptions-item>
     
            </el-descriptions>
  
                  <div class="formHeader mt30">
            <div class="line"></div>
            <div class="formHeaderText">技术创新亮点</div>
          </div>
          <div>
            <el-descriptions  direction="vertical" :column="3" border>
    <el-descriptions-item label="技术创新高度">{{achievementDetail?.height_str}}</el-descriptions-item>
    <el-descriptions-item label="技术创新属性">{{achievementDetail?.attribute_str}}</el-descriptions-item>
    <el-descriptions-item label="技术创新成果">{{achievementDetail?.achievement_str}}</el-descriptions-item>
          </el-descriptions>
          </div>
  
          
          <div class="formHeader mt30">
            <div class="line"></div>
            <div class="formHeaderText">市场价值要点
            </div>
          </div>
          <div>
            <el-descriptions  direction="vertical" :column="3" border>
    <el-descriptions-item label="核心产品市场形态">{{achievementDetail?.shape_str}}</el-descriptions-item>
    <el-descriptions-item label="项目已实现市场规模">{{achievementDetail?.scale_str}}</el-descriptions-item>
    <el-descriptions-item label="项目未来市场预期">{{achievementDetail?.expect_str}}</el-descriptions-item>
          </el-descriptions>
          </div>
  
  
          <div class="formHeader mt30">
            <div class="line"></div>
            <div class="formHeaderText">转化要素难点
  
            </div>
          </div>
          <div>
            <el-descriptions  direction="vertical" :column="3" border>
    <el-descriptions-item label="转化所需资源难度">{{achievementDetail?.difficulty_str}}</el-descriptions-item>
    <el-descriptions-item label="转化资源到位程度">{{achievementDetail?.degree_str}}</el-descriptions-item>
    <el-descriptions-item label="转化项目投资力度">{{achievementDetail?.strength_str}}</el-descriptions-item>
          </el-descriptions>
          </div>
  
  
  
  
          <div class="formHeader mt30">
            <div class="line"></div>
            <div class="formHeaderText">转化已实现进程
  
            </div>
          </div>
          <div>
            <el-descriptions  direction="vertical" :column="1" border>
    <el-descriptions-item label="TRL1-9">{{achievementDetail?.trl1_9_str}}</el-descriptions-item>
          </el-descriptions>
          </div>
  
  
          <div class="formHeader mt30">
            <div class="line"></div>
            <div class="formHeaderText">研发负责人
  
            </div>
          </div>
          <div>
            <el-descriptions  direction="vertical" :column="3" border>
    <el-descriptions-item label="姓名">{{achievementDetail?.leader_name}}</el-descriptions-item>
    <el-descriptions-item label="学历">{{achievementDetail?.leader_education_str}}</el-descriptions-item>
    <el-descriptions-item label="职称">{{achievementDetail?.leader_title_str}}</el-descriptions-item>
          </el-descriptions>
          </div>
  
          <div class="formHeader mt30">
            <div class="line"></div>
            <div class="formHeaderText">研发团队
  
            </div>
          </div>
          <div>
            <el-descriptions  direction="vertical" :column="3" border>
    <el-descriptions-item label="团队人数">{{achievementDetail?.team_person_str}}</el-descriptions-item>
    <el-descriptions-item label="中级以上人员占比">{{achievementDetail?.team_intermediate_str}}</el-descriptions-item>
    <el-descriptions-item label="团队合作经验">{{achievementDetail?.team_experience_str}}</el-descriptions-item>
          </el-descriptions>
          </div>
          
  
          <div class="formHeader mt30">
            <div class="line"></div>
            <div class="formHeaderText">附件
  
            </div>
          </div>
          <div v-for="value in achievementDetail?.attachment" :key="value.id">
            <div class="file-item" @click="handleDownload(value)">
              <i class="el-icon-document"></i>
              <el-button type="text" >{{value.file_name}}</el-button>
            </div>
          </div>
      </div>
  
    </el-collapse-item>
  
  
  </el-collapse>
  
  
  
  
    
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">关闭</el-button>
      </span>
    </el-dialog>
  </template>
  
  <script>
  export default {
    name: 'CooperativeServicesDialog',
    data() {
      return {
        recommendationDetail:{},
        dialogVisible: false,
        loading: false,
        achievementDetail: {},
        copDetail:{},
        attachmentList: []
      }
    },
    methods: {
      open(row) {
        this.dialogVisible = true
        this.loading = true
        
        // 等待所有接口完成后再关闭 loading
        this.getDate(row).finally(() => {
          this.loading = false
        })
      },
      getDate(row){
        return Promise.all([
        this.$API.getCopDetail({xid:row.xid}).then(red => {
            this.copDetail = red.data
          }).catch(err => {
          }),
          this.$API.getAchievementDetail({xid:row.project_item_xid}).then(res => {
            this.achievementDetail = res.data
          }), 

        ])
      },
      formatValue(value) {
        if (!value && value !== 0) {
          return '未选择'
        }
        if (value == 1) {
          return '是'
        }
        if (value == 2) {
          return '否'
        }
        return value
      },
      handleClose() {
        this.achievementDetail = {}
        this.attachmentList = []
      },
      getStateType(state) {
        const typeMap = {
          0: 'warning',  // 待推荐
          1: 'success',  // 已推荐
          2: 'danger'    // 已驳回
        }
        return typeMap[state] || 'info'
      },
      getStateText(state) {
        const textMap = {
          0: '待推荐',
          1: '已推荐',
          2: '已驳回'
        }
        return textMap[state] || '未知'
      },
      handleDetail() {
        this.dialogVisible = false
        // 打开详细弹框
        this.$refs.detailDialog.open(this.formData)
      },
      handleDownload(file) {
        if (!file.file_path) {
          this.$message.warning('文件路径不存在')
          return
        }
        window.open(file.file_path, '_blank')
      }
    }
  }
  </script>
  
  <style lang="scss" scoped>
  .file-item {
    i {
      margin-right: 10px;
      color: #409EFF;  /* 默认蓝色 */
      font-size: 18px;
    }
    
  
  }
   ::v-deep .labelClass{
    width: 150px !important;
  }
  .mt20{
    margin-top: 20px;
  }
  .reTitle {
    font-family: Microsoft YaHei, Microsoft YaHei;
    font-weight: 400;
    font-size: 30px;
    color: black;
    line-height: 30px;
    text-align: center;
  
  }
  .pd30{
    padding:10px 30px;
  }
  .borderTop{
    border-top: 1px solid #EBEEF5;
  }
  ::v-deep .el-collapse-item__header{
    padding-left: 10px;
  }
  ::v-deep .preview-container{
    border-left: 1px solid #EBEEF5;
    border-right: 1px solid #EBEEF5;
  }
  .achievement-preview-dialog {
    ::v-deep .el-dialog__body {
      padding: 0 20px 20px;
      max-height: 70vh;
      overflow-y: auto;
    }
  }
  
  .preview-container {
    padding: 0;
  }
  
  .preview-section {
    margin-bottom: 25px;
    padding-bottom: 20px;
    border-bottom: 1px dashed #e4e7ed;
  
    &:last-child {
      border-bottom: none;
      margin-bottom: 0;
    }
  }
  
  .section-header {
    display: flex;
    align-items: center;
    margin-bottom: 15px;
  }
  
  .section-line {
    width: 3px;
    height: 16px;
    background: #2F86FF;
    margin-right: 10px;
  }
  
  .section-title {
    font-family: Microsoft YaHei, Microsoft YaHei;
    font-weight: 500;
    font-size: 16px;
    color: #231815;
  }
  
  .info-item {
    display: flex;
    align-items: flex-start;
    margin-bottom: 12px;
  }
  
  .info-label {
    font-family: Microsoft YaHei, Microsoft YaHei;
    font-weight: 400;
    font-size: 14px;
    color: #595959;
    white-space: nowrap;
    flex-shrink: 0;
  }
  
  .info-value {
    font-family: Microsoft YaHei, Microsoft YaHei;
    font-weight: 400;
    font-size: 14px;
    color: #303133;
    word-break: break-all;
  }
  
  .profile-content {
    font-family: Microsoft YaHei, Microsoft YaHei;
    font-weight: 400;
    font-size: 14px;
    color: #303133;
    line-height: 1.8;
    padding: 15px;
    background: #f5f7fa;
    border-radius: 4px;
  
    ::v-deep img {
      max-width: 100%;
      height: auto;
    }
  }
  
  .file-list {
    .file-item {
      display: flex;
      align-items: center;
      padding: 12px 15px;
      background: #f5f7fa;
      border-radius: 4px;
      margin-bottom: 10px;
      cursor: pointer;
      transition: all 0.3s;
  
      &:hover {
        background: #ecf5ff;
  
        i {
          color: #2F86FF;
        }
      }
  
      i {
        margin-right: 10px;
        color: #409EFF;
        font-size: 18px;
      }
  
      span {
        flex: 1;
        font-size: 14px;
        color: #303133;
      }
    }
  }
  
  .no-data {
    padding: 40px 20px;
    text-align: center;
    color: #909399;
    font-size: 14px;
  
    i {
      font-size: 24px;
      margin-right: 8px;
    }
  }
  .mt30{
    margin-top: 30px;
  }
  
  .formHeaderText {
    font-family: Microsoft YaHei, Microsoft YaHei;
    font-weight: 400;
    font-size: 14px;
    color: #231815;
  
  }
  
  .formHeader {
    display: flex;
    align-items: center;
    margin-bottom: 10px;
  }
  
  .line {
    width: 3px;
    height: 19px;
    background: #2F86FF;
    margin-right: 10px;
  }
  </style>
  